import { defineMessages } from "react-intl";
export var messages = defineMessages({
  dismissButton: {
    id: "jutro-components.widgets.Toast.dismiss",
    defaultMessage: "Dismiss notification"
  }
});